// The top menu, in the old site's order (Home, Calendar, Events, Resources,
// ...). It is written here, not read from Plone's page tree: Swimming, Diving
// and the rest sit at the top level of the site, and their URLs stay as they
// are, so the groups cannot come from the hierarchy. To change a tab, change
// this list. `items` makes a tab a dropdown; its own page is the first entry
// or the tab's link.
export const MENU = [
  { title: 'Home', url: '' },
  { title: 'Calendar', url: '/calendar' },
  {
    title: 'Events',
    url: '/events',
    items: [
      { title: 'Events', url: '/events' },
      { title: 'Results', url: '/results' },
    ],
  },
  { title: 'Resources', url: '/resources' },
  { title: 'Rankings & Records', url: '/rankings' },
  { title: 'National Teams', url: '/national-teams' },
  {
    title: 'Disciplines',
    url: '/disciplines',
    items: [
      { title: 'Swimming', url: '/swimming' },
      { title: 'Diving', url: '/diving' },
      { title: 'Artistic Swimming', url: '/synchro' },
      { title: 'Water Polo', url: '/water-polo' },
    ],
  },
  {
    title: 'About',
    url: '/about',
    items: [
      { title: 'About the ASAJ', url: '/about' },
      { title: 'Contact', url: '/contact' },
      { title: 'Financial statements', url: '/financials' },
    ],
  },
];

// The classic look's menu: the old site's twelve flat tabs, in its order
export const CLASSIC_MENU = [
  { title: 'Home', url: '' },
  { title: 'Calendar', url: '/calendar' },
  { title: 'Contact', url: '/contact' },
  { title: 'Events', url: '/events' },
  { title: 'News', url: '/news' },
  { title: 'Resources', url: '/resources' },
  { title: 'Results', url: '/results' },
  { title: 'Diving', url: '/diving' },
  { title: 'Swimming', url: '/swimming' },
  { title: 'Artistic Swimming', url: '/synchro' },
  { title: 'Water Polo', url: '/water-polo' },
  { title: 'About the ASAJ', url: '/about' },
];

export const menuFor = (look) => (look === 'classic' ? CLASSIC_MENU : MENU);

// The shape Volto's navigation state has: every entry has `items`, because
// the phone menu reads `items.length` on each of them
export function menuItems(menu = MENU) {
  return menu.map(({ title, url, items = [] }) => ({
    title,
    url,
    '@id': url,
    items: items.map((child) => ({ ...child, '@id': child.url, items: [] })),
  }));
}

// Same test VLT uses: the page itself or anything below it
export function isActiveUrl(url, pathname) {
  if (url === '') return pathname === '/';
  return pathname === url || pathname.startsWith(`${url}/`);
}

// A tab is current on its own pages and on its dropdown's pages
export function isTabActive(tab, pathname) {
  return (
    isActiveUrl(tab.url, pathname) ||
    (tab.items ?? []).some((child) => isActiveUrl(child.url, pathname))
  );
}
